<template>
<div >
  <br>
    <br>

        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
             <el-tab-pane label="教练月报表" name="second" :key="'second'"  >
                <child2 v-if="isRouterAlive" ></child2>   
                <!-- <component  :is="zcfzVue"></component>  -->
            </el-tab-pane>
            <el-tab-pane label="教练日报表" name="first" :key="'first'" >
                <child1 v-if="isRouterAlive" ></child1>
                                <!-- <component  :is="cjlrVue"></component>  -->

            </el-tab-pane>
    

        </el-tabs>
        
    </div>



</template>

<script>
import Item1 from '@/views/ShopManagement/CoachlogReportDay.vue'
import Item2 from '@/views/ShopManagement/CoachlogReport.vue'

// const zcfzCont = resolve =>require(['@/views/MemberManagement/Item2.vue'], resolve)
// import tabZujianChild2 from '@/tabComponents/tabZujianChild2'
  export default {
     name: 'tabZujian',
    components:{
        child1:Item1,
        child2:Item2,
    },
    data() {
      return {
        activeName2: 'first',
        // 刷新子组件
        isRouterAlive: true,
       
      };
      
    },
    methods: {
      handleClick(tab, event) {
        //    this.$store.commit('changeapplyTab', tab.name)
        //    switch (tab.name) {
        //         case 'first' :
        //   // console.log('six')
        //   this.cjlrVue = Item1Cont
        //   break
        // case 'second' :
        //   // console.log('sevent')
        //   this.zcfzVue = lszpzCont
        //   break
        // }
        //   alert(tab.name);\
        // if(tab.name==='second')
        // {
          this.reload();
        // }
        // console.log(tab);

        // this.$router.push({ path: '/Item1' });
      },
       reload () {
     this.isRouterAlive = false
     this.$nextTick(() => (this.isRouterAlive = true))
   }   
    }
  };
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// CoachlogReportTavsView.vue?349e7cfc